import axios from "axios";
import qs from "qs";

let instance;

/** Returns the current instance of the SDK */
export const getInstance = () => instance;

export const useAxios = ({ apiUrl, auth }) => {
  if (instance) return instance;

  // The 'instance' is simply a Vue object

  instance = axios.create({
    baseURL: apiUrl,
    timeout: 1000 * 60 * 3,
    headers: {
      post: {
        "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
      },
      get: {
        "Content-Type": "application/json"
      }
    },
    paramsSerializer: params => {
      return qs.stringify(params, {
        arrayFormat: "brackets"
      });
    }
  });

  instance.interceptors.request.use(
    async config => {
      const token = await auth.getTokenSilently();
      // console.log("token: ", token);

      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  // function axiosCall () {
  //   return Axios.post(URL, {apiKey}).then(response => response.data.message);
  // }

  // instance.interceptors.request.use(function(config) {
  //   // Do something before request is sent
  //   // let authKey = config.getAuthKey;

  //   if (auth) {
  //     auth.getTokenSilently().then(token => {
  //       console.log("token: ", token);
  //       config.headers["Authorization"] = "Basic " + token;
  //     });
  //   }
  //   return config;
  // });

  instance.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      return Promise.reject(error);
    }
  );
  console.log("axios instance: ", instance);
  return instance;
};

// Vue.prototype.$http = axios;

// Create a simple Vue plugin to expose the wrapper object throughout the application
export const HttpPlugin = {
  install(Vue, options) {
    console.log("options: ", options);
    Vue.prototype.$http = useAxios(options);
  }
};
